import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  roleCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'roleModel',
    'featureModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Role,
      Feature
    ) {
      'use strict';

      function sortColumns() {
        return [
          { column: 'name', title: 'NAME', type: 'text', sortOrder: 'asc' },
          {
            column: 'description',
            title: 'DESCRIPTION',
            type: 'text',
            sortOrder: 'asc',
          },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = [];
        deferred.resolve(filters);
        return deferred.promise;
      }

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE ROLE'),
        };
      }

      function list() {
        var deferred = $q.defer();

        var url = 'roles';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Role(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function listFolderRoles(idFolder) {
        var deferred = $q.defer();

        var url = 'folders/roles/' + idFolder;

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Role(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function selectFeatures(role, features) {
        role.RolesFeatures.forEach((c) => {
          var fs = features.filter((f) => f.id === c.Feature);
          fs[0].selected = true;
        });
        role.allFeatures = features;
      }

      function load(id) {
        var deferred = $q.defer();

        var role = new Role();
        var features = null;
        var featuresDone = false;
        $http
          .get(webApiSettings.apiServiceBaseUri + 'roles/features', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;
              features = [];
              data.forEach(function (d) {
                var feature = new Feature(d, false);
                features.push(feature);
              });

              if (id && role.id !== 0 && !featuresDone) {
                selectFeatures(role, features);
                featuresDone = true;
                deferred.resolve(role);
              } else if (!id && !featuresDone) {
                role.allFeatures = features;
                featuresDone = true;
                deferred.resolve(role);
              }
            },
            function (err) {
              deferred.reject({ error: err.data, status: err.status });
            }
          );

        if (id) {
          $http
            .get(webApiSettings.apiServiceBaseUri + 'roles/' + id, {
              ignoreLoadingBar: true,
            })
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                role = new Role(data);

                if (features !== null && !featuresDone) {
                  selectFeatures(role, features);
                  featuresDone = true;
                  deferred.resolve(role);
                }
              },
              function (err) {
                deferred.reject({ error: err.data, status: err.status });
              }
            );
        }

        return deferred.promise;
      }

      function save(role) {
        var deferred = $q.defer();

        role.RolesFeatures = [];

        var features = role.allFeatures.filter((c) => c.selected);

        features.forEach((f) => {
          role.RolesFeatures.push({ IdRole: role.id, Feature: f.id });
        });

        if (role.id === 0) {
          $http
            .post(webApiSettings.apiServiceBaseUri + 'roles', role, {
              ignoreLoadingBar: true,
            })
            .then(() => deferred.resolve())
            .catch((err) => deferred.reject(handleError(err.data, err.status)));
        } else {
          $http
            .put(webApiSettings.apiServiceBaseUri + 'roles', role, {
              ignoreLoadingBar: true,
            })
            .then(() => deferred.resolve())
            .catch((err) => deferred.reject(handleError(err.data, err.status)));
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var url = 'roles/removelist/';
        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }

        $http
          .post(webApiSettings.apiServiceBaseUri + url, ids)
          .then(() => {
            deferred.resolve(true);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function run() {
        try {
          var roleCrudFactory = {};

          roleCrudFactory.folders = [];

          roleCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          roleCrudFactory.listFolderRoles = logWrapper(
            listFolderRoles,
            runtimeConstant.isDebugServicesInternals
          );

          return roleCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
